import {
    trigger,
    style,
    animate,
    transition,
    AnimationMetadata,
    group,
    query,
    AnimationTriggerMetadata,
} from '@angular/animations';
export class Animations {
    public static enterState(timing: number = 500, isLeaveAnimationPresent: boolean = true): AnimationTriggerMetadata {
        const leaveAnimationTransition: AnimationMetadata = transition(':leave', [
            style({ opacity: 1 }),
            animate(`${timing}ms cubic-bezier(0.940, 0.460, 0.450, 0.940)`, style({ opacity: 0 })),
        ]);

        const transitions: AnimationMetadata[] = [
            transition(':enter', [
                style({ opacity: 0 }),
                animate(`${timing}ms cubic-bezier(0.940, 0.460, 0.450, 0.940)`, style({ opacity: 1 })),
            ]),
        ];

        if (isLeaveAnimationPresent) {
            transitions.push(leaveAnimationTransition);
        }

        return trigger('enterAnimation', transitions);
    }

    public static fade: AnimationTriggerMetadata = trigger('fade', [
        transition('void => *', [style({ opacity: 0 }), animate(100, style({ opacity: 1 }))]),
        transition('* => void', [animate(100, style({ opacity: 0 }))]),
    ]);

    public static slideInOut(): AnimationTriggerMetadata {
        const slideRightAnimationTransition: AnimationMetadata = transition(':increment', [
            query(
                ':enter',
                [
                    style({
                        transform: 'translateX(100%)',
                    }),
                ],
                { optional: true },
            ),
            group([
                query(':enter', [animate('.3s ease-out', style({ transform: 'translateX(0%)' }))], { optional: true }),
                query(
                    ':leave',
                    [
                        style({
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                        }),
                        animate('.3s ease-out', style({ transform: 'translateX(-100%)' })),
                    ],
                    { optional: true },
                ),
            ]),
        ]);
        const slideLeftAnimationTransition: AnimationMetadata = transition(
            ':decrement',
            group([
                query(':enter', [
                    style({ transform: 'translateX(-100%)' }),
                    animate('.3s ease-out', style({ transform: 'translateX(0%)' })),
                ]),
                query(':leave', [
                    style({ transform: 'translateX(0%)' }),
                    animate('.3s ease-out', style({ transform: 'translateX(100%)' })),
                ]),
            ]),
        );

        return trigger('slideInOut', [slideRightAnimationTransition, slideLeftAnimationTransition]);
    }

    public static fadeWidth(timing: number = 200): AnimationTriggerMetadata {
        return trigger('fadeWidth', [
            transition(':enter', [
                style({
                    opacity: 0,
                    width: '0px',
                    minWidth: '0px',
                    marginLeft: '0px',
                    marginRight: '0px',
                    paddingLeft: '0px',
                    paddingRight: '0px',
                }),
                animate(
                    `${timing}ms cubic-bezier(0.22, 0.61, 0.36, 1)`,
                    style({
                        opacity: 1,
                        width: '*',
                        minWidth: '*',
                        marginLeft: '*',
                        marginRight: '*',
                        paddingLeft: '*',
                        paddingRight: '*',
                    }),
                ),
            ]),
            transition(':leave', [
                animate(
                    `${timing}ms cubic-bezier(0.22, 0.61, 0.36, 1)`,
                    style({
                        opacity: 0,
                        width: '0px',
                        minWidth: '0px',
                        marginLeft: '0px',
                        marginRight: '0px',
                        paddingLeft: '0px',
                        paddingRight: '0px',
                    }),
                ),
            ]),
        ]);
    }

    public static fadeHeight(timing: number = 200): AnimationTriggerMetadata {
        return trigger('fadeHeight', [
            transition(':enter', [
                style({
                    opacity: 0,
                    height: '0px',
                    minHeight: '0px',
                    marginTop: '0px',
                    marginBottom: '0px',
                    paddingTop: '0px',
                    paddingBottom: '0px',
                }),
                animate(
                    `${timing}ms cubic-bezier(0.22, 0.61, 0.36, 1)`,
                    style({
                        opacity: 1,
                        height: '*',
                        minHeight: '*',
                        marginTop: '*',
                        marginBottom: '*',
                        paddingTop: '*',
                        paddingBottom: '*',
                    }),
                ),
            ]),
            transition(':leave', [
                animate(
                    `${timing}ms cubic-bezier(0.22, 0.61, 0.36, 1)`,
                    style({
                        opacity: 0,
                        height: '0px',
                        minHeight: '0px',
                        marginTop: '0px',
                        marginBottom: '0px',
                        paddingTop: '0px',
                        paddingBottom: '0px',
                    }),
                ),
            ]),
        ]);
    }
}
